var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-header"},[_c('div',{staticClass:"header",class:{
      'over-baseline': (_vm.scrollY >= 600),
    }},[_c('div',{staticClass:"to-top",on:{"click":_vm.top}},[_c('img',{attrs:{"src":require("@/assets/logo001.webp")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }